import React from 'react';
import { useIntl } from 'react-intl';

import { Button, Grid } from '@xsolla/ui-core';
import { NewTab } from '@xsolla/ui-icons';

import { Blocks, Coloration, ComputerIcon, Graph, PeopleProfile, TopUp } from '../../../assets';
import { PROJECT_LINKS } from '../../../constants';
import { useConfig } from '../../../contexts/config';
import { InfoCard } from '../../index';
import { HeaderTitle } from '../../ui';
import { DocLink, DocLinkLabel, WrapperFeatures } from './style';

const LoginStartPageFeatures = (): JSX.Element => {
  const intl = useIntl();
  const { xsollaAnalytics } = useConfig();
  const { FEATURES } = PROJECT_LINKS;

  return (
    <WrapperFeatures>
      <HeaderTitle title={intl.formatMessage({ id: 'welcome-page.features-list.title' })} />

      <Grid cols={3} gap={16}>
        <InfoCard
          title={intl.formatMessage({ id: 'welcome-page.features-list.make-game.title' })}
          content={intl.formatMessage({ id: 'welcome-page.features-list.make-game.description' })}
          icon={<ComputerIcon />}
        />
        <InfoCard
          title={intl.formatMessage({ id: 'welcome-page.features-list.data-laws.title' })}
          content={intl.formatMessage({ id: 'welcome-page.features-list.data-laws.description' })}
          icon={<TopUp />}
        />
        <InfoCard
          title={intl.formatMessage({ id: 'welcome-page.features-list.brand-identity.title' })}
          content={intl.formatMessage({
            id: 'welcome-page.features-list.brand-identity.description'
          })}
          icon={<Coloration />}
        />
        <InfoCard
          title={intl.formatMessage({ id: 'welcome-page.features-list.own-your-database.title' })}
          content={intl.formatMessage({
            id: 'welcome-page.features-list.own-your-database.description'
          })}
          icon={<PeopleProfile />}
        />
        <InfoCard
          title={intl.formatMessage({
            id: 'welcome-page.features-list.relevant-login-methods.title'
          })}
          content={intl.formatMessage({
            id: 'welcome-page.features-list.relevant-login-methods.description'
          })}
          icon={<Blocks />}
        />
        <InfoCard
          title={intl.formatMessage({
            id: 'welcome-page.features-list.earn-layout-security.title'
          })}
          content={intl.formatMessage({
            id: 'welcome-page.features-list.earn-layout-security.description'
          })}
          icon={<Graph />}
        />
      </Grid>
      <DocLink>
        <a href={FEATURES} target="_blank" rel="noreferrer">
          <Button
            data-test-id="btn-more-features"
            look="tertiary"
            palette="brand"
            size="lg"
            onClick={() =>
              xsollaAnalytics.sendExternalLink('login_pa_module__dashboard__guid_link', FEATURES, {
                pageType: 'start_page'
              })
            }>
            <DocLinkLabel>
              {intl.formatMessage({ id: 'welcome-page.features-list.dock-link' })}
            </DocLinkLabel>
            <NewTab />
          </Button>
        </a>
      </DocLink>
    </WrapperFeatures>
  );
};

export default LoginStartPageFeatures;
